/**
 * Human-readable allowance for the "Refresh allowance" toast.
 *
 * Polymarket's "infinite approval" sets the on-chain allowance to MaxUint256
 * (2^256 − 1). In USDC dollar units (÷10^6) that surfaces as ~1.157e71, which
 * `toFixed(2)` renders as `1.157920892373162e+71` — a real value, but it reads
 * like a bug to anyone looking at it. Collapse any max-approval-sized value to
 * a word; show a genuine allowance as dollars.
 *
 * The $1e15 (one quadrillion) cut is orders of magnitude above any conceivable
 * real allowance (USDC total supply is ~$1e11) yet far below the ~1e71 sentinel,
 * and the non-finite guard catches an Infinity from an overflowed coercion.
 * Callers pass a finite number (the refresh handler coerces with `|| 0`), so NaN
 * does not occur here.
 */
export function formatAllowance(usd: number): string {
  if (!Number.isFinite(usd) || usd >= 1e15) return 'unlimited';
  return `$${usd.toFixed(2)}`;
}

/** True when an allowance value is the max-approval sentinel (drives the
 *  explanatory tooltip on the toast). */
export function isUnlimitedAllowance(usd: number): boolean {
  return !Number.isFinite(usd) || usd >= 1e15;
}
